module.exports = __webpack_public_path__ + "img/bento_nascimento.651e4e6b.png";